<template>
  <div
    class="ccui-multifunctional-table-wrapper ccui-multifunctional-table-wrapper-detail"
  >
    <template v-if="type != 2">
      <div class="operate">
        <el-upload
          class="upload-demo tow"
          :data="formData"
          :action="uploadForm.action"
          :before-upload="beforeAvatarUpload"
          :on-success="uploadSuccess"
          :show-file-list="false"
          :on-error="uploadError"
          :on-progress="onProgress"
          :headers="uploadForm.headers"
          multiple
        >
          <el-button plain type="single-number">业绩证明上传</el-button>
        </el-upload>
      </div>
      <div class="clearfix"></div>
    </template>
    <el-table
      :data="fileTableData"
      border
      class="dic-sub-table-style01"
      :style="this.$route.query.type === 'add' ? '' : 'margin-top:20px'"
    >
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column
        prop="fileName"
        label="附件名称"
        show-overflow-tooltip
        width="200"
      ></el-table-column>
      <el-table-column
        prop="fileSize"
        label="附件大小"
        show-overflow-tooltip
        width="100"
      >
        <template slot-scope="{ row }"> {{ row.fileSize }}kb </template>
      </el-table-column>
      <el-table-column prop="fileDesc" label="附件说明"  show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="type != 2 && fileSummType != 1">
            <el-input
              v-model="scope.row.fileDesc"
              placeholder="请输入附件说明"
              maxlength="500"
              show-word-limit
            />
          </template>
          <template v-else>{{ scope.row.fileDesc }}</template>
        </template>
      </el-table-column>
      <el-table-column
        prop="uploadTime"
        label="上传时间"
        show-overflow-tooltip
        :width="dateTimeWidth"
      ></el-table-column>
      <el-table-column type="action" label="操作" width="130">
        <template slot-scope="scope">
          <el-button type="text" @click="download(scope.$index, scope.row)"
            >下载</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="scope.row.uploadId && scope.row.isShowViewBtn && type == 2"
            @click="preview(scope.row.uploadId)"
          >
            预览
          </el-button>
          <template v-if="type != 2">
            <el-button type="text" @click="deleteRow(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--- 上传附件填写基本信息 -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { pageTableWidth } from "@/setting/setting";
import { addUrlPerFix, isShowViewBtn } from "@/utils";
import { Loading } from "ccui";
// import { findFileInfo } from "@/api/index";

export default {
  name: "attachmentUpload",
  props: {
    fileData: {
      type: Array,
      default() {
        return [];
      }
    },
    // id: {
    //   type: String, // 编辑、复制、查看详情
    //   default: ""
    // },
    type: {
      type: Number, // 0：编辑、新增 1:复制 2： 查看详情
      default: 0
    },
    fileSummType: {
      type: Number, // 1 只能查看
      default: 0
    },
    isMultipleFlag: {
      //是否多文件上传标识
      type: Boolean,
      default: false
    },
    isImage: {
      type: Boolean,
      default: false
    },
    isSupportPDF: {
      // isImage为true时，是否支持上传PDF格式
      type: Boolean,
      default: false
    }
  },
  watch: {
    fileData: {
      handler(val) {
        val.forEach(item => {
          item.isShowViewBtn = isShowViewBtn(item.fileName);
          console.log(val, "val");
        });
        this.fileTableData = val;
      },
      immediate: true,
      deep: true
    }
    // fileData(val) {
    //   val.forEach(item => {
    //     item.isShowViewBtn = isShowViewBtn(item.fileName);
    //   });
    //   console.log(val);
    //   this.fileTableData = val;
    // }
  },
  data() {
    return {
      dateTimeWidth: pageTableWidth.dateTimeWidth,
      uploadForm: {
        action:
          this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
          "/apis/sra/reg/users/signup/uploadFileToOss",
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      formData: {
        agentId: this.$router.history.current.query.a
      },
      fileTableData: this.fileData,
      uploadLoading: null,
      deletePlanAttachementList: [] // 删除的数据
    };
  },
  deactivated() {
    this.fileTableData = [];
    this.deletePlanAttachementList = [];
    this.uploadLoading && this.uploadLoading.close();
  },
  methods: {
    uploadSuccess(res, file, fileList) {
      console.log(res);
      this.uploadLoading && this.uploadLoading.close();
      let fileData = res.data[0];
      let fileNameDuplication = false;
      if (this.fileTableData && this.fileTableData.length > 0) {
        this.fileTableData.forEach(item => {
          if (fileData.fileName == item.fileName) {
            fileNameDuplication = true;
          }
        });
      }
      if (fileNameDuplication) {
        this.$message({
          message: "请不要上传重名附件，请编辑后重新上传",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData.uploadId) {
        this.$message({
          message: "上传ID不能为空！请重新上传文件",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData.downloadUrl) {
        this.$message({
          message: "文件URL不能为空！请重新上传文件",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      this.$message({
        message: "附件上传成功",
        type: "success",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      let obj = {
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: fileData.fileSumm,
        fileDesc: fileData.fileDesc,
        uploadTime: fileData.createTime,
        // createTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId
      };
      if (this.isMultipleFlag) {
        this.fileTableData = [obj];
      } else {
        this.fileTableData.push(obj);
      }
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "上传出错，请联系管理员",
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading && this.uploadLoading.close();
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      const isLt50 = file.size < 104857600;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      let extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "ppt" ||
        testmsg === "pptx" ||
        testmsg === "pdf" ||
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "txt" ||
        testmsg === "rft" ||
        testmsg === "msg" ||
        testmsg === "wps" ||
        testmsg === "et" ||
        testmsg === "dps" ||
        testmsg === "vsd" ||
        testmsg === "prn" ||
        testmsg === "ai" ||
        testmsg === "cad" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "PDF" ||
        testmsg === "tiff" ||
        testmsg === "TIFF" ||
        testmsg === "swf" ||
        testmsg === "SWF" ||
        testmsg === "bmp" ||
        testmsg === "gif" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "rar" ||
        testmsg === "RAR" ||
        testmsg === "zip" ||
        testmsg === "7z" ||
        testmsg === "lzh" ||
        testmsg === "ofd" ||
        testmsg === "LZH";
      if (this.isImage) {
        extension =
          testmsg === "xbm" ||
          testmsg === "XBM" ||
          testmsg === "tif" ||
          testmsg === "TIF" ||
          testmsg === "pjp" ||
          testmsg === "PJP" ||
          testmsg === "svgz" ||
          testmsg === "SVQZ" ||
          testmsg === "ico" ||
          testmsg === "ICO" ||
          testmsg === "tiff" ||
          testmsg === "TIFF" ||
          testmsg === "jpeg" ||
          testmsg === "JPEG" ||
          testmsg === "jpg" ||
          testmsg === "JPG" ||
          testmsg === "png" ||
          testmsg === "PNG" ||
          testmsg === "svg" ||
          testmsg === "SVG" ||
          testmsg === "jfif" ||
          testmsg === "JFIF" ||
          testmsg === "webp" ||
          testmsg === "WEBP" ||
          testmsg === "bmp" ||
          testmsg === "BMP" ||
          testmsg === "pjpeg" ||
          testmsg === "PJPEG" ||
          testmsg === "avif" ||
          testmsg === "AVIF" ||
          testmsg === "GIF" ||
          testmsg === "gif";
        if (this.isSupportPDF) {
          extension = extension || testmsg === "pdf" || testmsg === "PDF";
        }
      }
      if (!isLt50) {
        this.uploadLoading && this.uploadLoading.close();
        this.$message({
          message: "文件大小不可超过100M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过100M！");
      }
      //是否有后缀
      let fileType = file.name.indexOf(".") != -1;
      if (!extension && fileType) {
        this.uploadLoading && this.uploadLoading.close();
        let message = "上传文件格式错误！";
        if (this.isImage) {
          message = "上传图片格式错误！";
        }
        this.$message({
          message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && (extension || !fileType);
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/scma/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    preview(uploadId) {
      // findFileInfo({ fileGxId: uploadId }).then(res => {
      //   if (res.data.data) {
      //     // var downloadUrl = res.data.data.downloadUrl;
      //     // var fileName = res.data.data.fileName;
      //     // const win = window.open("about:blank");
      //     // win.document.title = fileName;
      //     // const iframe = document.createElement("iframe");
      //     // iframe.src = downloadUrl + "#toolbar=0";
      //     // iframe.style.width = "100%";
      //     // iframe.style.height = "100vh";
      //     // iframe.style.margin = "0";
      //     // iframe.style.padding = "0";
      //     // iframe.style.overflow = "hidden";
      //     // iframe.style.border = "none";
      //     // win.document.body.style.margin = "0";
      //     // win.document.body.appendChild(iframe);
      //     window.open(res.data.data.downloadUrl);
      //   }
      // });
    },
    deleteRow(index, row) {
      if (row.fileinfoId) {
        this.deletePlanAttachementList.push(row.fileinfoId);
      }
      this.fileTableData.splice(index, 1);
    }
  },
  mounted() {
    console.log(this.fileTableData);
  }
};
</script>

<style lang="scss" scoped>
.operate {
  float: right;
  margin: 0 !important;
}
/deep/ {
  .el-input input {
    padding-right: 60px;
  }
}
.overFlow_txt {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
/deep/.el-button.el-button--single-number {
  border: 1px solid #ff142f;
  background: #fff;
  span {
    color: #ff142f;
  }
  &:hover {
    border-color: #ff142f;
    background: #ff142f;

    span {
      color: #fff;
    }
  }
}
.el-button.el-button--single-number.is-plain:focus,
.el-button.el-button--single-number.is-plain:hover {
  border-color: #ff142f;
}
</style>
